/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businesscreatedsuccessfully2Inputs */

const en_businesscreatedsuccessfully2 = /** @type {(inputs: Businesscreatedsuccessfully2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business created successfully`)
};

const de_businesscreatedsuccessfully2 = /** @type {(inputs: Businesscreatedsuccessfully2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen erstellt`)
};

/**
* | output |
* | --- |
* | "Business created successfully" |
*
* @param {Businesscreatedsuccessfully2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businesscreatedsuccessfully2 = /** @type {((inputs?: Businesscreatedsuccessfully2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businesscreatedsuccessfully2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businesscreatedsuccessfully2(inputs)
	return de_businesscreatedsuccessfully2(inputs)
});
export { businesscreatedsuccessfully2 as "businessCreatedSuccessfully" }